import { Dispatch } from 'redux';
import { generateGuestToken as generateGuestTokenApi } from '../api/guestToken';
import { CheckoutState } from '../state';
import { updateTokensWithGuestToken as updateTokensWithGuestTokenAction } from './tokens';

/**
 * This generates the token needed in the header to complete the order
 * It is NOT needed when there is already an existing order.
 *
 * @param dispatch redux dispatch function
 * @param eventId the event ID
 */
export const generateGuestToken = async (
    dispatch: Dispatch<CheckoutState>,
    eventId: string,
) => {
    const { response: tokenResponse } = await generateGuestTokenApi(eventId);

    if (!('guest_token' in tokenResponse)) {
        return;
    }

    await dispatch(updateTokensWithGuestTokenAction(tokenResponse.guest_token));
};
